<template>
  <v-container fluid>
    <div class="notify"></div>
    <modal
        name="errorModal"
        width="50%"
        height="50%"
        class="p-5"
    >
      <button
          class="close p-2"
          @click="closeModal"
      >
        <span class="dingbat">✖</span>
      </button>
      <div class="p-5 d-flex align-center justify-center h-100 flex-column">
        <v-img
            src="@/assets/images/services/ready/Warningsign.png"
            class="mr-auto ml-auto"
            width="300"
            height="300"
            contain
        />
        <h3 class="text-center mt-5">
          {{errorText}}
        </h3>
      </div>
    </modal>
    <div class="own-wrap shift-page" v-if="shiftOpen">
      <section
          class="shift-page__container"
          :class="{ 'd-none': displayNone }"
      >
        <v-row class="cards">
          <v-col class="cards__col">
            <div class="card shift-page__card command__body">

              <div class="card__body card__body--p-0">
                <div
                    class="panel__header command__header d-flex align-items-center justify-content-between"
                >
                  <div>
                    <img
                        src="images/shift/icon/taem.png"
                        alt=""
                    />
                    <span class="command">Команда</span>
                  </div>
                  <a
                      href=""
                      data-toggle="tooltip"
                      title="Какой нибудь текст внутри этого блока"
                  >
                    <i class="icon__info">
                      <img
                          src="images/shift/icon/info.png"
                          alt=""
                      />
                    </i>
                  </a>
                </div>
                <div class="card__inner">
                  <button class="btn mb-1 mt-1 btn-success w-100 panel__title" @click="showMasters = !showMasters">
                    {{ showMasters ? 'скрыть' : 'показать' }}
                    мастеров
                  </button>
                  <div
                      v-if="showMasters"
                      class="panel__body panel__body--flex"
                  >
                    <div
                        class="active worker"
                        v-for="worker in workers"
                        :key="worker.id"
                    >
                      <master-shift-badge
                          :worker="worker"
                          :type="'master'"
                          :styleType="'row'"
                          @showContextModal="showContextModal"
                      >
                      </master-shift-badge>
                    </div>
                    <div
                        class="master"
                        @click.prevent="openAvailableEmployeesModal"
                    >
                      <a
                          href=""
                          class="worker__add"
                      >
                        <span>+</span>
                        <div
                            class="worker__position mt-1"
                        >
                          <span>мастер</span>
                        </div>
                      </a>
                    </div>
                  </div>
                  <button class="btn btn-success mt-1 mb-1 w-100 panel__title" @click="showSupports = !showSupports">
                    {{ showSupports ? 'скрыть' : 'показать' }}
                    помощников
                  </button>
                  <div
                      v-if="showSupports"
                      class="panel__body  panel__body--flex"
                  >

                    <div
                        class="active worker"
                        v-for="assistant in assistants"
                        :key="assistant.id"
                    >
                      <master-shift-badge
                          :worker="assistant"
                          :type="'assistant'"
                          :styleType="'row'"
                      ></master-shift-badge>
                    </div>
                    <div
                        class="master"
                        @click.prevent="openAvailableAssistantsModal"
                    >
                      <a
                          href=""
                          class="assistant__img d-flex align-items-center justify-content-center overflow-hidden"
                      >
                        <div
                            class="assistant__position mt-1"
                        >
                          <span>+</span>
                          <br/>
                          <span>помощник</span>
                        </div>
                      </a>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </v-col>
          <v-col class="cards__col">
            <div class="card salary__body  disabled">
              <div class="card__body card__body--p-0">
                <div
                    class="panel__header salary__header "
                >
                  <div>
                    <img
                        src="images/shift/icon/salary-icon.png"
                        alt=""
                    />
                    <span class="command">Зарплата</span>
                  </div>
                  <a
                      href=""
                      data-toggle="tooltip"
                      title="Какой нибудь текст внутри этого блока"
                  >
                    <i class="icon__info">
                      <img
                          src="images/shift/icon/info.png"
                          alt=""
                      /></i>
                  </a>
                </div>
                <div class="panel__body ">
                  <div class="accordion" id="salaryAccordeon">
                    <div
                        class="card z-depth-0 bordered"
                        v-for="worker in workers"
                        :key="worker.id"
                        @click.prevent.stop="
                                                handleClick1($event, worker)
                                            "
                    >
                      <div
                          class="card-header"
                          id="headingOne"
                      >
                        <h5 class="mb-0">
                          <button
                              class="sb-list-row"
                              type="button"
                              data-toggle="collapse"
                              data-target="#collapseOne"
                              aria-expanded="true"
                              aria-controls="collapseOne"
                          >
                                                        <span
                                                            class="d-flex align-items-center"
                                                        >
                                                            <i
                                                                class="fa fa-caret-right mr-1"
                                                            ></i>
                                                            <span
                                                                class="border-bottom-1"
                                                            >{{
                                                                worker.name
                                                              }}</span
                                                            >
                                                        </span>
                            <span class="rubl">
                                                            {{
                                numberWithSpaces(
                                    Math.floor(
                                        worker
                                            .salary
                                            .zp
                                            .summ
                                    ).toFixed()
                                )
                              }}
                                                            <i
                                                                class="font-normal"
                                                            >₽</i
                                                            >
                                                        </span>
                            <span
                                v-if="
                                                                Math.floor(
                                                                    worker
                                                                        .salary
                                                                        .zp
                                                                        .additional
                                                                )
                                                            "
                                class="rubl"
                            >
                                                            +{{
                                numberWithSpaces(
                                    Math.floor(
                                        worker
                                            .salary
                                            .zp
                                            .additional
                                    ).toFixed()
                                )
                              }}
                                                            <i
                                                                class="font-normal"
                                                            >₽</i
                                                            >
                                                        </span>
                          </button>
                        </h5>
                      </div>
                      <div
                          id="collapseOne"
                          class="collapse"
                          aria-labelledby="headingOne"
                          data-parent="#salaryAccordeon"
                      >
                        <!--                        <div class="card-body">-->
                        <!--div class="bon">
                            <a href="" class="rubl" data-master="200398776391">115</a> <span
                            class="font-normal">+</span>
                            <a href="" class="rubl" data-master="200398776392">69</a> <span
                            class="font-normal">+</span>
                            <a href="" class="rubl" data-master="200398776393">50</a> <span
                            class="font-normal">+</span>
                            <a href="" class="rubl" data-master="200398776394">212</a> <span
                            class="font-normal">+</span>
                            <a href="" class="rubl" data-master="200398776395">105</a>
                        </div-->
                        <!--                        </div>-->
                      </div>
                    </div>
                    <div class="card z-depth-0 bordered">
                      <!--div class="card-header" id="headingTwo">
                          <h5 class="mb-0">
                              <button class="btn btn-link btn btn-link d-flex w-100 align-items-center justify-content-between"
                                      type="button" data-toggle="collapse"
                                      data-target="#collapseTwo" aria-expanded="false"
                                      aria-controls="collapseTwo">
                          <span class="d-flex align-items-center">
                              <i class="fa fa-caret-right mr-1"></i>
                              <span>Помощник</span>
                          </span>
                                  <span class="rubl"> 315 <i class="font-normal">₽</i></span>
                              </button>
                          </h5>
                      </div-->

                      <!--div id="collapseTwo" class="collapse" aria-labelledby="headingTwo"
                           data-parent="#salaryAccordeon">
                          <div class="card-body">
                              <div class="bon">
                                  <a href="" class="rubl" data-worker="200398776391">115</a> <span
                                  class="font-normal">+</span>
                                  <a href="" class="rubl" data-worker="200398776392">69</a> <span
                                  class="font-normal">+</span>
                                  <a href="" class="rubl" data-worker="200398776393">50</a> <span
                                  class="font-normal">+</span>
                                  <a href="" class="rubl" data-worker="200398776394">212</a> <span
                                  class="font-normal">+</span>
                                  <a href="" class="rubl" data-worker="200398776395">105</a>
                              </div>
                          </div>
                      </div-->
                    </div>
                  </div>
                </div>
              </div>
              <div
                  class="card-footer"
              >
                <a href="">
                  <img
                      src="../assets/images/shift/icon/history.png"
                      width="90%"
                      alt=""
                  />
                </a>
                <b>
                  {{
                    numberWithSpaces(
                        Math.floor(
                            shiftInfo.total_workers_salary
                        ).toFixed()
                    )
                  }}
                  <i class="font-normal">₽</i></b
                >
              </div>
            </div>
          </v-col>
          <v-col class="cards__col">
            <div class="card bonus__body ">
              <div class="card-body  p-0">
                <div
                    class="panel__header "
                >
                  <div>
                    <img
                        src="images/shift/icon/bonus.png"
                        alt=""
                    />
                    <span class="command">Бонусы</span>
                  </div>
                  <a
                      href=""
                      data-toggle="tooltip"
                      title="Какой нибудь текст внутри этого блока"
                  >
                    <i class="icon__info">
                      <img
                          src="images/shift/icon/info.png"
                          alt=""
                      /></i>
                  </a>
                </div>
                <div class="panel__body  ">
                  <div class="accordion" id="bonusAccordeon">
                    <div
                        class="card z-depth-0 bordered"
                        v-for="(worker, index) in workers"
                        :key="'workers-'+index"
                    >
                      <div
                          class="card-header"
                          id="headingOne"
                      >
                        <h5 class="mb-0">
                          <button
                              class="sb-list-row"
                              type="button"
                              data-toggle="collapse"
                              data-target="#collapseOne"
                              aria-expanded="true"
                              aria-controls="collapseOne1"
                          >
                            <span
                                class="d-flex align-items-center"
                            >
                                <i
                                    class="fa fa-caret-right mr-1"
                                ></i>
                                <span
                                    class="border-bottom-1"
                                >{{
                                    worker.name
                                  }}</span
                                >
                            </span>
                            <span class="rubl">
                              {{
                                numberWithSpaces(
                                    Math.floor(
                                        worker
                                            .salary
                                            .bonus
                                            .summ
                                    ).toFixed()
                                )
                              }}
                              <i class="font-normal">₽</i>
                            </span>
                          </button>
                        </h5>
                      </div>
                      <div
                          id="collapseOne1"
                          class="collapse"
                          aria-labelledby="headingOne"
                          data-parent="#salaryAccordeon"
                      >
                        <!--                        <div class="card-body">-->
                        <!--div class="bon">
                            <a href="" class="rubl" data-master="200398776391">115</a> <span
                            class="font-normal">+</span>
                            <a href="" class="rubl" data-master="200398776392">69</a> <span
                            class="font-normal">+</span>
                            <a href="" class="rubl" data-master="200398776393">50</a> <span
                            class="font-normal">+</span>
                            <a href="" class="rubl" data-master="200398776394">212</a> <span
                            class="font-normal">+</span>
                            <a href="" class="rubl" data-master="200398776395">105</a>
                        </div-->
                        <!--                        </div>-->
                      </div>
                    </div>
                    <div class="card z-depth-0 bordered">
                    </div>
                  </div>
                </div>
              </div>
              <div
                  class="card-footer"
              >
                <a href="">
                  <img
                      src="../assets/images/shift/icon/history.png"
                      width="90%"
                      alt=""
                  />
                </a>
                <b>
                  {{ numberWithSpaces(Math.floor(shiftInfo.total_workers_bonus).toFixed()) }}
                  <i class="font-normal">₽</i></b>
              </div>
            </div>
          </v-col>
          <v-col class="cards__col">
            <div
                class="card moneybox"
                :class="{ active: shiftInfo.moneybox ? shiftInfo.moneybox.status : false }"
            >
              <div class="card-body  p-0">
                <div
                    class="panel__header "
                >
                  <div>
                    <img
                        src="images/shift/icon/moneybox.png"
                        alt=""
                    />
                    <span class="command">Копилка</span>
                  </div>
                  <a
                      href=""
                      data-toggle="tooltip"
                      title="Какой нибудь текст внутри этого блока"
                  >
                    <i class="icon__info">
                      <img
                          src="images/shift/icon/info.png"
                          alt=""
                      /></i>
                  </a>
                </div>
                <div class="panel__body  ">
                  <div class="empty__text">
                    <p>
                      Копилка включается когда более
                      {{
                        shiftInfo.moneybox
                            ? shiftInfo.moneybox
                                .required_employees
                            : ""
                      }}
                      человек в команде
                    </p>
                  </div>
                  <div class="moneybox_bon">
                    <!-- <a href="" class="rubl" data-moneybox="200398776391">115</a> <span
                    class="font-normal">+</span>
                    <a href="" class="rubl" data-moneybox="200398776392">69</a> <span
                    class="font-normal">+</span>
                    <a href="" class="rubl" data-moneybox="200398776393">50</a> <span
                    class="font-normal">+</span>
                    <a href="" class="rubl" data-moneybox="200398776394">212</a> <span
                    class="font-normal">+</span>
                    <a href="" class="rubl" data-moneybox="200398776395">105</a> -->
                  </div>
                </div>
              </div>
              <div
                  class="card-footer card-footer--column"
                  v-if="shiftInfo.result_cars && shiftInfo.moneybox.total_sum_without_charges > 0"
              >
                <b>
                  Всего
                  {{
                    shiftInfo.result_cars
                        ? numberWithSpaces(
                            Math.floor(
                                shiftInfo.moneybox
                                    .total_sum_without_charges
                            ).toFixed()
                        )
                        : "0"
                  }}<i class="font-normal">₽</i>
                </b>
                <br/>
                <b
                    v-if="
                                        shiftInfo.result_cars &&
                                            shiftInfo.moneybox
                                                .total_sum_without_charges > 0
                                    "
                >
                  Осталось
                  {{
                    shiftInfo.result_cars
                        ? numberWithSpaces(
                            Math.floor(
                                shiftInfo.moneybox
                                    .total_sum
                            ).toFixed()
                        )
                        : "0".toString()
                  }}<i class="font-normal">₽</i>
                </b>
              </div>
            </div>
          </v-col>
          <v-col class="cards__col">
            <div class="card achievements active">
              <div class="card-body  p-0">
                <div
                    class="panel__header "
                >
                  <div>
                    <img
                        src="images/shift/icon/achievements.png"
                        alt=""
                    />
                    <span class="command">Достижения</span>
                  </div>
                  <a
                      href=""
                      data-toggle="tooltip"
                      title="Какой нибудь текст внутри этого блока"
                  >
                    <i class="icon__info">
                      <img
                          src="images/shift/icon/info.png"
                          alt=""
                      /></i>
                  </a>
                </div>
                <div class="panel__body  ">
                  <div class="row">
<!--                    <div class="col">-->
<!--                      <div class="bg-ff average-check">-->
<!--                        <span class="inf">Средний чек смены</span>-->
<!--                        <img src="images/shift/icon/achievements-1.png" class="icon" alt="">-->
<!--                        <b class="num rubl">-->
<!--                          {{ averagecheck }}-->
<!--                          <i class="font-normal">₽</i>-->
<!--                        </b>-->
<!--                      </div>-->
<!--                    </div>-->
                    <!-- <div class="col">
                    <div class="col">
                        <div
                            class="bg-ff d-flex align-items-center justify-content-center"
                        >
                            <span class="inf"
                                >Средний чек в течение
                                плана</span
                            >
                            <img
                                src="images/shift/icon/achievements-2.png"
                                class="icon"
                                alt=""
                            />
                            <b class="num rubl"
                                >{{
                                    numberWithSpaces(
                                        Math.floor(
                                            getFinplanCurrentAmount(
                                                finplan
                                            ) /
                                                finplan.ordersCount,
                                            2
                                        )
                                    )
                                }}<i class="font-normal"
                                    >₽</i
                                ></b
                            >
                        </div>
                    </div> -->
                    <template v-if="averageMotivityReceipt">
                        <v-col
                            cols="12"
                            class="col my-1 px-0"
                            v-for="(averageReceipt, index) in averageMotivityReceipt"
                            :key="'aver-' + index"
                        >
                          <div
                              class="bg-ff d-flex align-items-center justify-content-between"
                          >
                                                    <span class="inf">{{
                                                        averageReceipt.title
                                                      }}</span>
                            <b class="num rubl"
                            >{{
                                averageReceipt &&
                                averageReceipt.averageMotivityReceipt
                                    ? numberWithSpaces(
                                        averageReceipt.averageMotivityReceipt
                                    )
                                    : Math.floor(
                                        0
                                    ).toFixed()
                              }}<i class="font-normal"
                              >₽</i
                              ></b
                            >
                          </div>
                        </v-col>
                      </template>
                  </div>
                  <finplans></finplans>
                </div>
              </div>
            </div>
          </v-col>
        </v-row>
        <v-row class="table__block d-flex flex-wrap">
          <v-col class="col-xl-8">
            <div class="table-head w-100">
              <div>
                <img
                    src="images/shift/table-icons/zakaz.png"
                    alt=""
                />
                <span>Заказ-наряды {{ shiftInfoText }}</span>
              </div>
              <span
                  class="button-hide"
                  @click="hideDeleted = !hideDeleted"
              >
                                <div class="pointer" v-if="!hideDeleted">
                                    Скрыть удалённые
                                </div>
                                <div class="pointer" v-else>
                                    Показать удалённые
                                </div>
                            </span>
              <span>Заказов: {{ orders.length }}</span>
            </div>
            <div class="for-scrolling">
              <table
                  class="table table-borderless"
                  id="scrollTable"
              >
                <thead>
                <tr>
                  <th>Номер</th>
                  <th>Дата</th>
                  <th>Время</th>
                  <th>Выполнен</th>
                  <!--th>Диаметр</th-->
                  <th>Тип авто</th>
                  <th>Оплата</th>
                  <th>Стоимость</th>
                  <th>ЗП мастера</th>
                  <th>Бонусы</th>
                  <th>В копилку</th>
                  <th>ЗП админа</th>
                  <th>ЗП кассира</th>
                  <th>Скидка</th>
                  <th>Мастер</th>
                  <th></th>
                </tr>
                </thead>
                <tbody>
                <tr
                    v-for="(item, index) in orders"
                    :class="{
                                            striked: item.basic.deleted,
                                            hidden:
                                                item.basic.deleted &&
                                                hideDeleted
                                        }"
                    :key="'orders-'+index"
                    @click="selectOrder(index)"
                >
                  <td>
                    <img
                        src="images/shift/table-icons/sm_full.png"
                        class="mr-2"
                        alt=""
                    />{{ item.basic.number }}
                  </td>
                  <td class="create_date">
                    {{ item.basic.date }}
                  </td>
                  <td class="create_time">
                    {{ item.basic.finish_time }}
                  </td>
                  <td>
                    <div
                        class="status-box"
                        :class="
                                                    statusClass(
                                                        item.basic.status
                                                    )
                                                "
                    ></div>
                  </td>
                  <!--td class="for_car_tire">R14</td-->
                  <td class="for_car_img">
                    <img
                        v-if="item.basic.car_type_slug"
                        :src="
                                                    carTypeIco(
                                                        item.basic.car_type_slug
                                                    )
                                                "
                        alt=""
                    />
                  </td>
                  <td class="for_pay_icon">
                    <!--img src="images/shift/table-icons/pay2.png" alt=""-->{{
                      item.basic.wage_type
                    }}
                  </td>
                  <td class="rubl work_price">
                    {{
                      numberWithSpaces(
                          Math.floor(
                              item.result.total
                          )
                      )
                    }}
                    <template
                        v-if="item.result.total > 0"
                    ><i class="font-normal"
                    >₽</i
                    ></template
                    >
                  </td>
                  <td class="fs-12 rubl">
                    {{
                      numberWithSpaces(
                          Math.round(
                              item.result
                                  .zn_worker_salary
                          )
                      )
                    }}
                    <template
                        v-if="
                                                    item.result
                                                        .zn_worker_salary > 0
                                                "
                    ><i class="font-normal"
                    >₽</i
                    ></template
                    >
                  </td>
                  <td class="fs-12 rubl">
                    {{
                      numberWithSpaces(
                          Math.round(
                              item.result
                                  .zn_worker_bonus
                          )
                      )
                    }}
                    <template
                        v-if="
                                                    item.result
                                                        .zn_worker_bonus > 0
                                                "
                    ><i class="font-normal"
                    >₽</i
                    ></template
                    >
                  </td>
                  <td class="fs-12 rubl">
                    <i class="font-normal">-</i>
                  </td>
                  <td class="fs-12 rubl">
                    {{
                      numberWithSpaces(
                          Math.round(
                              item.result
                                  .zn_admin_salary
                          )
                      )
                    }}
                    <template
                        v-if="
                                                    item.result
                                                        .zn_admin_salary > 0
                                                "
                    ><i class="font-normal"
                    >₽</i
                    ></template
                    >
                  </td>
                  <td class="fs-12 rubl">
                    {{
                      numberWithSpaces(
                          Math.round(
                              item.result
                                  .zn_cashier_salary
                          )
                      )
                    }}
                    <template
                        v-if="
                                                    item.result
                                                        .zn_cashier_salary > 0
                                                "
                    ><i class="font-normal"
                    >₽</i
                    ></template
                    >
                  </td>
                  <td class="rubl">
                    {{
                      numberWithSpaces(
                          Math.round(
                              item.result.discount
                          )
                      )
                    }}
                    <template
                        v-if="item.result.discount > 0"
                    ><i class="font-normal"
                    >₽</i
                    ></template
                    >
                  </td>
                  <td>{{ item.basic.worker }}</td>
                  <td>
                    <a
                        href=""
                        class="trash"
                        data-no="200398776391"
                    ><img
                        src="images/shift/table-icons/bin.png"
                        alt=""
                    /></a>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </v-col>
          <v-col class="col-xl-4">
            <div class="cashbox">
              <div class="mb-2">
                <div
                    class="cassa d-flex align-items-center justify-content-between"
                >
                                    <span
                                    ><img
                                        src="images/shift/icon/cassa.png"
                                        alt=""
                                    />
                                        Касса</span
                                    >
                  <b class="arr fs-18 rubl"
                  >{{
                      shiftInfo.result_cars
                          ? numberWithSpaces(
                              Math.floor(
                                  shiftInfo.result_cars
                                      .total_cars_sum
                              )
                          )
                          : ""
                    }}
                    <i class="font-normal">₽</i></b
                  >
                </div>
                <div class="cassa_block">
                  <ul
                      class="list-group list-group-horizontal bg-transparent justify-content-between fs-12 m-0 pl-0"
                  >
                    <li class="list-group-item mx-1 col">
                      <div>
                        <img
                            src="images/shift/icon/cassa-car.png"
                            alt=""
                        />
                        <span class="ml-2"
                        >Авто за смену</span
                        >
                      </div>
                      <b
                      >{{
                          shiftInfo.result_cars
                              ? shiftInfo.result_cars
                                  .total_cars
                              : ""
                        }}
                        шт.</b
                      >
                    </li>
                  </ul>
                  <div class="mt-3 mb-6 d-flex w-100">
                    <div
                        class="cassa_percent cart position-relative"
                        data-percent="60"
                    >
                                            <span class="rubl"
                                            >{{
                                                shiftInfo.result_cars
                                                    ? numberWithSpaces(
                                                        Math.floor(
                                                            shiftInfo
                                                                .result_cars
                                                                .total_cards_sum
                                                        )
                                                    )
                                                    : "0"
                                              }}
                                                ₽({{
                                                shiftInfo.result_cars
                                                    ? shiftInfo.result_cars
                                                        .total_cards
                                                    : "0"
                                              }})
                                            </span>
                      <span class="absolute"
                      ><img
                          src="images/shift/icon/card.png"
                          alt=""
                      /></span>
                    </div>
                    <div
                        class="cassa_percent check position-relative"
                        data-percent="5"
                    >
                                            <span class="rubl"
                                            >{{
                                                shiftInfo.result_cars
                                                    ? numberWithSpaces(
                                                        Math.floor(
                                                            shiftInfo
                                                                .result_cars
                                                                .total_legals_sum
                                                        )
                                                    )
                                                    : "0"
                                              }}
                                                ₽({{
                                                shiftInfo.result_cars
                                                    ? shiftInfo.result_cars
                                                        .total_legals
                                                    : "0"
                                              }})
                                            </span>
                      <span class="absolute center"
                      ><img
                          src="images/shift/icon/check.png"
                          alt=""
                      /></span>
                    </div>
                    <div
                        class="cassa_percent cash position-relative"
                        data-percent="35"
                    >
                                            <span class="rubl"
                                            >{{
                                                shiftInfo.result_cars
                                                    ? numberWithSpaces(
                                                        Math.floor(
                                                            shiftInfo
                                                                .result_cars
                                                                .total_cash_sum
                                                        )
                                                    )
                                                    : "0"
                                              }}
                                                ₽({{
                                                shiftInfo.result_cars
                                                    ? shiftInfo.result_cars
                                                        .total_cash
                                                    : "0"
                                              }})</span
                                            >
                      <span class="absolute r-0"
                      ><img
                          src="images/shift/icon/cash.png"
                          alt=""
                      /></span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="mb-2">
                <div class="total pb-3">
                  <ul
                      class="list-group list-group-horizontal bg-transparent justify-content-between fs-12 m-0 p-0"
                  >
                    <li class="list-group-item p-0 m-0 ">
                                            <span class="fs-16"
                                            >Итого сдать
                                                администратору:</span
                                            >
                    </li>
                    <li class="list-group-item ml-1">
                      <b class="fs-18 rubl no-space-wrap"
                      >{{
                          shiftInfo.result_cars
                              ? numberWithSpaces(
                                  Math.floor(
                                      shiftInfo
                                          .result_cars
                                          .to_admin
                                  )
                              )
                              : ""
                        }}
                        <i class="font-normal">₽</i></b
                      >
                    </li>
                  </ul>
                  <div class="text-center">
                    <button
                        type="button"
                        class="btn btn-primary"
                        :class="{
                                                disabled:
                                                    !shiftInfo.result_cars ||
                                                    closeShiftButtonDisabled
                                            }"
                        @click="showModal"
                        data-test-id="closeShiftButton"
                    >
                      Закрыть смену
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </v-col>
        </v-row>
      </section>
    </div>
    <div class="container text-center total mt-5" v-else-if="!shiftLoading">
      <open-shift/>
    </div>
    <v-dialog v-model="shiftLoading" persistent width="300">
      <v-card color="#C7C7C7" dark>
        <v-card-text>
          Загрузка
          <v-progress-linear
              indeterminate
              color="black"
              class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!--надо модалки в компоненты отдельные-->
    <v-dialog v-model="orderInfo" max-width="1150">
      <v-card>
        <v-card-title>
          Услуги в заказ-наряде
          {{ selectedOrder.basic ? selectedOrder.basic.number : "" }}
        </v-card-title>
        <v-card-text>
          <v-data-table
              :headers="headers"
              :items="selectedOrder.services"
              :items-per-page="10"
              class="elevation-1"
          ></v-data-table>
        </v-card-text>

        <v-list class="transparent">
          <v-list-item>
            <v-list-item-title>А/М:</v-list-item-title>
            <v-list-item-subtitle>{{
                selectedOrder.basic ? selectedOrder.basic.car : ""
              }}
            </v-list-item-subtitle>
          </v-list-item>
          <v-list-item>
            <v-list-item-title>Сумма заказа:</v-list-item-title>
            <v-list-item-subtitle
            >{{
                selectedOrder.basic
                    ? numberWithSpaces(
                        selectedOrder.result.total
                    )
                    : "0"
              }}
              ₽
            </v-list-item-subtitle
            >
          </v-list-item>
          <v-list-item>
            <v-list-item-title>ЗП мастера:</v-list-item-title>
            <v-list-item-subtitle
            >{{
                selectedOrder.basic
                    ? numberWithSpaces(
                        selectedOrder.result.zn_worker_salary
                    )
                    : "0"
              }}
              ₽
            </v-list-item-subtitle
            >
          </v-list-item>
          <v-list-item>
            <v-list-item-title
            >ЗП администратора:
            </v-list-item-title
            >
            <v-list-item-subtitle
            >{{
                selectedOrder.basic
                    ? numberWithSpaces(
                        selectedOrder.result.zn_admin_salary
                    )
                    : "0"
              }}
              ₽
            </v-list-item-subtitle
            >
          </v-list-item>
          <v-list-item>
            <v-list-item-title>Бонус мастера:</v-list-item-title>
            <v-list-item-subtitle
            >{{
                selectedOrder.basic
                    ? numberWithSpaces(
                        selectedOrder.result.zn_worker_bonus
                    )
                    : "0"
              }}
              ₽
            </v-list-item-subtitle
            >
          </v-list-item>
          <v-list-item>
            <v-list-item-title>Копилка:</v-list-item-title>
            <v-list-item-subtitle
            >{{
                selectedOrder.basic
                    ? numberWithSpaces(
                        selectedOrder.result
                            .zn_moneybox_salary
                    )
                    : "0"
              }}
              ₽
            </v-list-item-subtitle
            >
          </v-list-item>
          <v-list-item>
            <v-list-item-title>ЗП Кассира:</v-list-item-title>
            <v-list-item-subtitle
            >{{
                selectedOrder.basic
                    ? numberWithSpaces(
                        selectedOrder.result.zn_cashier_salary
                    )
                    : "0"
              }}
              ₽
            </v-list-item-subtitle
            >
          </v-list-item>
        </v-list>
        <template
            v-if="
                        autoAcquiring &&
                            selectedOrder.basic &&
                            selectedOrder.basic.status == 'paid' &&
                            selectedOrder.basic.wage_type == 'Карта'
                    "
        >
          <div class="p-4">
            <v-btn
                depressed
                color="error"
                :class="{
                                disabled: refundDisabled
                            }"
                @click="refundOrder(selectedOrder)"
            >
              Оформить возврат на карту
            </v-btn>
          </div>
        </template>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="warning" text @click="orderInfo = false">
            закрыть
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <choose-employees-modal/>
    <choose-assistants-modal/>
    <moneybox-not-empty-modal/>
    <context-modal/>
    <moneybox-to-employee-charge-modal/>
    <!--    <modal-->
    <!--        name="aqRefundModal"-->
    <!--        width="50%"-->
    <!--        height="95%"-->
    <!--        :clickToClose="false"-->
    <!--    >-->
    <!--      <div class="card-body text-center">-->
    <!--        <h5>-->
    <!--          Следуйте инструкциям на банковском терминале.-->
    <!--        </h5>-->
    <!--        <h5>-->
    <!--          И, пожалуйста, подождите, пока мы получим ответ от банка...-->
    <!--        </h5>-->
    <!--        <div>-->
    <!--          <v-progress-linear-->
    <!--              v-model="acquiringProgress"-->
    <!--              :buffer-value="acquiringProgressTotal"-->
    <!--              color="amber"-->
    <!--              height="25"-->
    <!--          ></v-progress-linear>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    </modal>-->
    <!--    <modal name="aqErrorModal" width="50%" height="95%">-->
    <!--      <div class="card-body text-center">-->
    <!--        <h3>Ошибка банковского терминала!</h3>-->
    <!--        <p>-->
    <!--          Код: {{ this.aqErrors.aq.error }} Ошибка:-->
    <!--          {{ this.aqErrors.aq.status }}-->
    <!--        </p>-->
    <!--        <button-->
    <!--            class="btn btn-success"-->
    <!--            @click.prevent="hideAqErrorModal()"-->
    <!--        >-->
    <!--          Ок-->
    <!--        </button>-->
    <!--      </div>-->
    <!--    </modal>-->
    <!--    <modal name="kkmErrorModal" width="50%" height="95%">-->
    <!--      <div class="card-body text-center">-->
    <!--        <h1>Ошибка кассового аппарата!</h1>-->
    <!--        <p>-->
    <!--          Код: {{ this.aqErrors.kkm.error }} Ошибка:-->
    <!--          {{ this.aqErrors.kkm.status }}-->
    <!--        </p>-->
    <!--        <button class="btn btn-success">Повторить печать чеков</button>-->
    <!--        <button-->
    <!--            class="btn btn-success"-->
    <!--            @click.prevent="hideKkmErrorModal()"-->
    <!--        >-->
    <!--          Выбрать другой способ оплаты-->
    <!--        </button>-->
    <!--      </div>-->
    <!--    </modal>-->
    <close-shift
        v-model="closeShiftModalShow"
        @cancelCloseShift="cancelCloseShift"
        @submitCloseShift="closeShift"
    />
    <v-row v-if="!shiftLoading && shiftOpen" class="shift-time">
      <v-col
          cols="12"
          class="text-center d-flex"
      >
        <div class="start-time">
          {{ msToHMS(startTime) }}
        </div>
        <div class="time-bar">
          {{ msToHMS(endTime) }}
        </div>
        <div class="end-time">
          {{ msToHMS(endTime) }}
        </div>
      </v-col>
    </v-row>
    <payment-modal v-if="paymentModal"/>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import axios from '../plugins/axios-common'

export default {
  data() {
    return {
      showErrorModal: false,
      errorText: '',
      showSupports: false,
      showMasters: true,
      showQq: false,
      loadState: false,
      headers: [
        {
          text: "Нименование",
          align: "start",
          sortable: false,
          value: "name"
        },
        { text: "Стоимость", value: "price" },
        { text: "Количество", value: "quantity" },
        { text: "Сумма", value: "sum" },
        { text: "Зарплата мастера", value: "worker_salary" },
        { text: "Зарплата администратора", value: "admin_salary" },
        { text: "Бонус мастера", value: "worker_bonus" },
        { text: "Копилка", value: "moneybox_salary" },
        { text: "Доп. ЗП мастера", value: "additional_master_salary" },
        {
          text: "Доп. ЗП администратора",
          value: "additional_admin_salary"
        },
        { text: "ЗП кассира", value: "cashier_salary" }
      ],
      hideDeleted: true,
      selectedOrder: { services: [] },
      orderInfo: false,
      shiftLoading: true,
      closeShiftModalShow: false,
      shiftOpen: false,
      closeShiftButtonDisabled: false,
      refundDisabled: false,
      acquiringProgress: 0,
      acquiringProgressTotal: 100,
      aqErrors: {
        kkm: {
          status: "",
          error: ""
        },
        aq: {
          status: "",
          error: ""
        }
      },
    }
  },
  components: {
    openShift: () => import("../components/shift/OpenShift.vue"),
    closeShift: () => import("../components/shift/closeShift.vue"),
    masterShiftBadge: () => import("../components/partials/team/MasterShiftBadge.vue"),
    paymentModal: () => import("../components/order/ChooseServices/PaymentModalNew.vue"),
    chooseEmployeesModal: () => import("../components/shift/ChooseEmployessModal.vue"),
    chooseAssistantsModal: () => import("../components/shift/ChooseAssistantsModal.vue"),
    moneyboxNotEmptyModal: () => import("../components/shift/MoneyboxNotEmptyModal.vue"),
    contextModal: () => import("../components/shift/ContextModalNew.vue"),
    moneyboxToEmployeeChargeModal: () => import("../components/shift/MoneyboxToEmployeeChrageModal.vue"),
    finplans: () => import("../components/partials/finplans/Finplans.vue")
  },
  computed: {
    ...mapGetters([
      "client",
      "userData",
      "displayNone",
      "paymentModal"
    ]),
    ...mapGetters('shift', [
      "moneybox",
      "shiftInfo",
      "moneyboxEmployee",
    ]),
    startTime() {
      if (this.shiftInfo.basic && this.shiftInfo.basic.start_date && this.shiftInfo.basic.start_time) {
        const [day, month, year] = this.shiftInfo.basic.start_date.split('.')
        const [hh, mm] = this.shiftInfo.basic.start_date.split('.')
        return new Date(year, month, day, hh, mm)
      } else {
        return new Date()
      }
    },
    endTime() {
      return new Date()
    },
    autoAcquiring() {
      return this.$store.getters['shift/autoAcquiring']
    },
    averagecheck() {
      if (this.shiftInfo.result_cars) {
        if (this.shiftInfo.result_cars.total_cars_sum && this.shiftInfo.result_cars.total_cars) {
          return this.numberWithSpaces(Math.floor(this.shiftInfo.result_cars.total_cars_sum / this.shiftInfo.result_cars.total_cars, 2).toFixed())
        }
      }
      return '0'
    },
    shiftInfoText() {
      let text = "";
      if (
          this.shiftInfo.basic &&
          this.shiftInfo.basic.number &&
          this.shiftInfo.basic.start_time
      ) {
        text =
            "Смена:" +
            this.shiftInfo.basic.number +
            " открыта в " +
            this.shiftInfo.basic.start_time +
            " " +
            this.shiftInfo.basic.start_date;
      }
      return text;
    },
    workers() {
      return this.shiftInfo.workers ? this.shiftInfo.workers : [];
    },
    assistants() {
      return this.shiftInfo.assistants ? this.shiftInfo.assistants : [];
    },
    motivation() {
      if (this.$store.state.motivation.status) {
        return this.$store.state.motivation.nominations
      } else {
        return []
      }
    },
    orders() {
      return this.shiftInfo.orders
          ? [...this.shiftInfo.orders].sort((a, b) => {
            let comparison = 0;
            if (a.basic.date < b.basic.date) {
              comparison = 1;
            } else if (a.basic.date > b.basic.date) {
              comparison = -1;
            } else if (a.basic.date === b.basic.date) {
              if (a.basic.finish_time < b.basic.finish_time) {
                comparison = 1;
              } else if (
                  a.basic.finish_time > b.basic.finish_time
              ) {
                comparison = -1;
              }
            }
            return comparison;
          })
          : [];
    },
    moneybox() {
      return this.shiftInfo.moneybox ? this.shiftInfo.moneybox : [];
    },
    averageMotivityReceipt() {
      return this.motivation &&
      this.motivation.length
          ? this.motivation.filter(
              item => !(item.averageMotivityReceipt === false || item.averageMotivityReceipt === undefined)
          )
          : 0;
    }
  },
  async mounted() {
    this.$store.dispatch("login/getWorkshop");
    this.$store
        .dispatch("shift/fetchShiftDataAxios")
        .then(resp => {
          this.shiftLoading = false;
          if (resp.opened) {
            this.shiftOpen = true;
          }
          //console.log('dsd',resp)
        })
        .catch(e => {
          console.log("error", e);
          this.shiftLoading = false;
        });
  },
  methods: {
    closeModal() {
      this.$modal.hide("errorModal");
    },
    showContextModal () {
      this.$store.dispatch('shift/setContextModal', true)
    },
    carTypeIco(id) {
      switch (id) {
        case "passenger":
          return "images/sedan.png";
        case "suv":
          return "images/jeep.png";
        case "gazelle":
          return "images/gazel.png";
        default:
          return "";
      }
    },
    cancelCloseShift() {
      this.closeShiftButtonDisabled = false
    },
    selectOrder(id) {
      this.selectedOrder = { services: [] };
      this.selectedOrder = this.orders[id];
      this.orderInfo = true;
    },
    getQq() {
      this.closeShiftModalShow = false;
      this.showQq = true
    },
    closeShift() {
      this.showQq = false
      this.$store.dispatch("shift/closeShift", this.shiftData).then(() => {
        this.$store.dispatch("shift/fetchShiftData")
        this.$store.dispatch("login/logout")
        this.$router.push('/login')
        this.modalShow = false
        this.closeShiftButtonDisabled = false;
      }).catch((err) => {
        this.errorText = err.data.message
        this.$modal.show("errorModal");
        this.modalShow = false
        this.closeShiftButtonDisabled = false;
      })
    },
    showModal() {
      this.closeShiftButtonDisabled = true;
      this.$store.dispatch("shift/fetchShiftDataAxios").finally(() => {
        if (this.shiftInfo.moneybox.total_sum !== "0.00") {
          this.$modal.show("moneyboxNotEmptyModal");
        } else {
          this.closeShiftModalShow = true;
        }
      });
    },
    hideModal() {
      this.$refs["confirmClose"].hide();
    },
    toggleModal() {
      // We pass the ID of the button that we want to return focus to
      // when the modal has hidden
      this.$refs["confirmClose"].toggle("#toggle-btn");
    },
    openAvailableEmployeesModal() {
      this.$modal.show("chooseEmployeesModal");
    },
    openAvailableAssistantsModal() {
      this.$modal.show("chooseAssistantsModal");
    },
    logout: function () {
      axios.post("/logout").then(() => (location.href = "/login"));
    },
    numberWithSpaces(x) {
      return x ? x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ") : "0";
    },
    motivationCheck() {
      //TODO: update shiftInfo
      // check that user is participant at least of one nomination
      if (
          this.motivation.status == "1" &&
          this.motivation.sliced &&
          !this.motivation.less20hours
      ) {
        let winners = this.motivation.winners;
        let results = "Результаты мотивити: <br/>";
        winners.forEach(element => {
          results += `В номинации ${ element.title } победил ${ element.fullName }. Мастерская ${ element.workshop }. Награда составила ${ element.reward } руб.<br/>`;
        });
        return results;
      } else if (
          this.motivation.status == "1" &&
          this.motivation.less20hours
      ) {
        return "Вы закрываете смену длительностью менее 20 часов. Данная смена не сможет быть учтена в системе Motivity. Для участия в Motivity необходима смена длительностью более 20 часов.";
      } else if (
          this.motivation.status == "1" &&
          !this.motivation.sliced &&
          !this.motivation.less20hours
      )
        return "Итоговые результаты MOTIVITY будут доступны в 10:00. Зарегистрируйтесь в телеграмм боте, чтобы получать уведомления о результатах каждую смену.";
    },
    statusClass(status) {
      let className = "";
      switch (status) {
        case "new":
        case "inprogress":
          className = "inprogress";
          break;
        case "ready":
          className = "ready";
          break;
        case "paymentpending":
          className = "paymentpending";
          break;
        case "paid":
          className = "paid";
          break;
        default:
          break;
      }
      return className;
    },
    refundOrder(order) {
      this.$store.commit('setPaymentRefund', { state: true, order: order })
      this.$store.dispatch('setPaymentModal', true)
    },
    sleep(milliseconds) {
      const date = Date.now();
      let currentDate = null;
      do {
        currentDate = Date.now();
      } while (currentDate - date < milliseconds);
    },
    msToHMS(ms) {
      let hours = ms.getHours()
      let minutes = ms.getMinutes()
      if (hours <= 9) {
        hours = '0' + hours
      }
      if (minutes <= 9) {
        minutes = '0' + minutes
      }
      return hours + ':' + minutes
    },
  }
};
</script>
<style scoped lang="scss">
.shift-time {
  bottom: 10px;
  position: absolute;
  width: 100%;
}

.start-time {
  margin-left: 14px;
}

.end-time {
  margin-right: 14px;
}

.time-bar {
  width: 100%;
  margin-left: 30px;
  margin-right: 30px;
  background-color: #00c851;
  color: white;
}

.average-check {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
}

.mdi-account-circle::before {
  margin-left: -19px;
}

.master-badge {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.sb-list {
  background-color: rgba(0, 0, 0, .03);
  padding: 1rem;
}

.sb-list-row {
  text-decoration: none;
  padding: 1px 0;
  margin: 0;
  font-size: 12px;
  text-transform: capitalize;
  display: flex;
  word-wrap: break-word;
  white-space: normal;
  border: 0;
  border-radius: 0.125rem;
  width: 100%;
  align-items: center;
  justify-content: space-between;
}

.worker {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: calc(50% - 10px);
  margin: 10px 5px;

  &__add {
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
  }
}

.master {
  width: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  position: relative;
  padding: 0 !important;
}

.cards {
  &__col {
    & + & {
      margin-right: 0.25rem;
    }
  }
}

.shift-page {
  display: flex;
  margin-top: 1rem;

  &__container {
    width: 100%;
    position: relative;
  }

  &__card {
    margin-right: .25rem
  }
}

.list-group {
  padding: 0;
  list-style-type: none;
}

.list-group-horizontal {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.card {
  position: relative;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-direction: column;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-radius: 0.25rem;
  height: 100%;

  & + & {
    margin-top: 1rem;
  }

  &__inner {
    max-height: 650px;
    overflow: auto;
    margin-bottom: auto;
  }

  &__body {
    -ms-flex: 1 1 auto;
    flex: 1 1 auto;
    min-height: 1px;
    padding: 1.25rem;

    &--p-0 {
      padding: 0;
    }
  }
}

.card-header {
  background-color: rgba(0, 0, 0, .03);
  padding: 0.75rem 1.25rem;
}

.table {
  width: 100%;
}

.pointer {
  cursor: pointer;
}

.total .btn.btn-orange {
  background: linear-gradient(to top, #eb944f, #f3b565);
}

/* STATUS BOX*/
.status-box {
  position: relative;
  height: 25px;
  width: 100%;
  border: 1px solid #626262;
}

.inprogress {
  background: linear-gradient(to right, #ffd083 40%, #ffffff 40%);
}

.ready {
  background: linear-gradient(to right, #7fc42f 60%, #ffffff 60%);
}

.paymentpending {
  background: linear-gradient(to right, #f98593 80%, #ffffff 80%);
}

.paid {
  background: #97c7ff;
}

.shift-info {
  text-align: center;
}

.button-hide {
  border: 1px solid #805b5b;
  border-radius: 9px;
  padding-left: 6px;
  padding-right: 6px;
  margin-left: auto;
  margin-right: 14px;
  font-size: small;
  color: dimgrey;
}

.minus-right-margin {
  margin-right: -10px;
}

.hidden {
  display: none;
}

body {
  font-family: "Istok Web", sans-serif;
  font-weight: 400;
}

@font-face {
  font-family: "Lucida Grande", sans-serif;
  src: url(../assets/fonts/lucidagrande.ttf);
}

@font-face {
  font-family: "ArialMT", sans-serif;
  src: url(../assets/fonts/Arial.woff);
}

.no-space-wrap {
  white-space: nowrap;
}

.font-normal {
  font-style: normal;
}

.fs-10 {
  font-size: 10px !important;
}

.fs-12 {
  font-size: 12px !important;
}

.fs-18 {
  font-size: 18px !important;
}

.fs-14 {
  font-size: 14px !important;
}

.fs-16 {
  font-size: 16px !important;
}

.position-unset {
  position: unset;
}

/*NAVBAR*/
#navbarSupportedContent-555 {
  align-items: flex-start;
}

.navbar {
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;
}

.time {
  font-family: "Goblin One", cursive;
  font-size: 30px;
  font-weight: 400;
}

.date {
  font-size: 11px;
}

.t__d {
  line-height: 20px;
}

header .nav-link {
  padding-left: 1em !important;
  padding-right: 1em !important;
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  line-height: 18px;
  text-decoration-line: underline;
  color: #4a90e2;
}

header nav {
  padding: 1em 1.5rem !important;
}

header .nav-item.active > .nav-link {
  color: #000;
}

li.event > a {
  position: relative;
}

li.event > a > .event__circle {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 0;
  right: 0;
  width: 20px;
  height: 20px;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
  background: #d0021b;
  font-size: 14px;
  font-family: "Lucida Grande", sans-serif;
  color: #fff;
}

.btn__animate {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.close__btn {
  width: 45px;
  height: 35px;
  padding: 2px;
  text-align: center;
  background: #ffaeb8;
}

/*PANELS*/

/*panel header*/
.panel__header {
  padding: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.command__header {
  background-color: #c7c7c7;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.panel__header .command {
  font-size: 14px;
  color: #000;
  font-weight: 600;
}

.panel__body {
  position: relative;

  &--flex {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
  }
}

/*panel body*/
.command__body .panel__body,
.salary__body .bonus__body,
.panel__body,
.achievements .panel__body {
  padding: 5px 10px;
  min-width: 200px;
}

.auto_width {
  flex-wrap: nowrap;
}

.card {
  height: 100%;
  justify-content: space-between;
  display: flex;
  flex-direction: column;
}

.auto_width .card-body {
  /*max-height: 215px;*/
  overflow: hidden;
}

.auto_width .card {
  margin: 0;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;
  -webkit-border-radius: 0;
  -moz-border-radius: 0;
  border-radius: 0;
}

.panel__top {
  display: flex;
  position: absolute;
  bottom: 100%;
  left: 0;
  width: 100%;
}

/*MASTERS*/
.master {
  padding: 3px 40px 3px 10px;
  border-radius: 5px 5px 0 0;
  font-style: italic;
  font-size: 12px;
  color: #000000;
}

.add__master {
  padding: 3px 40px;
  border-radius: 5px 5px 0 0;
  background: #9ccaff;
  font-size: 14px;
  text-align: center;
  color: #ffffff;
}

.worker__name {
  font-size: 12px;
  line-height: 14px;
  text-align: center;
  color: #000000;
}

.active .worker__name {
  font-weight: 600 !important;
}

.worker__img {
  position: relative;
  width: 60px;
  height: 60px;
  background: #d8d8d8;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.assistant__img {
  position: relative;
  width: 45px;
  height: 45px;
  background: #d8d8d8;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
}

.worker__add {
  position: relative;
  flex-direction: column;
  padding: 5px;
  width: 58px;
  height: 58px;
  background: #d8d8d8;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
  color: #4a4a4a;
  line-height: 10px;
}

.worker__add > span {
  font-size: 21px;
}

.worker__add .worker__position > span {
  font-size: 10px;
}

.close__worker {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 0;
  right: 0;
  width: 15px;
  height: 15px;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
  background: #d0021b;
}

.worker__position {
  line-height: 16px;
  font-size: 14px;
  text-align: center;
  font-style: italic;
  color: #000000;
}

.assistant__position {
  line-height: 14px;
  font-size: 10px;
  text-align: center;
  font-style: italic;
  color: #000000;
}

.command__btn {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 600;
  padding: 5px 10px;
}

.in__work {
  background: #fff688;
}

.in__home {
  background: #e9e9e9;
}

.in__work > span {
  font-size: 10px;
  line-height: 18px;
  color: #d0021b;
}

.btn-rounded {
  box-shadow: 0 2px 3px rgba(0, 0, 0, 0.5);
  border-radius: 9px;
}

.command__body {
  background: #e6e6e6;
}

/*salary*/
.salary__header {
  background: #ffc971;
}

.salary__body {
  background: #ffd083;
}

.salary__body .panel__body {
  padding: 10px;
}

.salary__body .card {
  background: transparent;
  border: none;
  padding: 0;
}

.bonus__body .card {
  background: transparent;
  border: none;
  padding: 0;
}

.salary__body .card .btn-link {
  display: flex;
  align-items: center;
  padding: 1px 0;
  margin: 0;
  font-size: 12px;
  text-transform: capitalize;
}

.bonus__body .card .btn-link {
  display: flex;
  align-items: center;
  padding: 1px 0;
  margin: 0;
  font-size: 12px;
  text-transform: capitalize;
}

.salary__body .card .btn-link:hover,
.salary__body .card .btn-link:focus {
  text-decoration: none;
}

.bonus__body .card .btn-link:hover,
.salary__body .card .btn-link:focus {
  text-decoration: none;
}

.salary__body .card .btn-link > span > span {
  border-bottom: 1px dashed #000;
  line-height: normal;
}

.bonus__body .card .btn-link > span > span {
  border-bottom: 1px dashed #000;
  line-height: normal;
}

.salary__body .card .btn-link .fa-caret-right {
  font-size: 20px;
}

.bonus__body .card .btn-link .fa-caret-right {
  font-size: 20px;
}

.auto_width > .card {
  padding-bottom: 15px !important;
  margin: 0;
  flex: 0 0 auto;
}

/*ACORDEON*/

#salaryAccordeon .card-body {
  padding: 5px 10px;
  font-size: 12px;
}

.card-footer {
  border: none;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 10px 5px;
}

.card-footer--column {
  flex-direction: column;
  align-items: flex-end;
}


.card-footer > a {
  padding: 3px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
  border-radius: 5px;
  background: #ffc971;
  text-align: center;
}

/*bonus*/
.bonus__body {
  background: #d2ffa1;
}

.bonus__body .panel__header {
  background: #c0fa7f;
}

.moneybox .panel__body {
  padding: 10px;
}

.bon,
.moneybox_bon {
  font-weight: normal;
  font-size: 12px;
  color: #000000;
  font-style: normal;
  line-height: 25px;
}

.bon a,
.moneybox_bon a {
  margin-top: 3px;
  padding: 1px 3px;
  border: 1px solid;
  color: #000000;
}

.rubl {
  text-align: right;
}

.bon .rubl.active {
  background: #ffd700;
}

/*moneybox*/
.moneybox .card-footer {
  /* display: none !important; */
}

.moneybox .panel__header {
  background: #cbcbcb;
}

.moneybox {
  background: #dddddd;
}

.moneybox_bon {
  display: none;
}

.empty__text {
  font-weight: normal;
  font-size: 12px;
  color: #939393;
}

.moneybox.active .card-footer {
  display: flex !important;
}

.moneybox.active .moneybox_bon {
  display: block;
}

.moneybox.active .empty__text {
  display: none;
}

.moneybox.active .panel__header {
  background: #dab1ff;
}

.moneybox.active {
  background: #e4c4ff;
}

.moneybox_bon a.active {
  background: #fcf7ad;
}

/*achievements*/
.achievements {
  background: #ffee99;
}

.achievements .panel__header {
  background: #ffd700;
}

.bg-f8 {
  padding: 5px;
  background: #f8e71c;
  line-height: 14px;
}

.bg-ff {
  padding: 5px;
  background: #fff9a8;
  line-height: 14px;
}

.achievements .panel__body .col {
  padding: 0 5px;
}

.achievements .panel__body .row {
  padding: 3px 5px;
  margin: 0;
}

.bg-f8 .inf {
  font-size: 22px;
}

.bg-f8 .num {
  border-color: #000 !important;
  font-size: 12px;
  padding: 2px;
}

.bg-f8 .icon,
.bg-ff .icon {
  margin: 0 10px;
}

.bg-ff span.inf {
  font-size: 12px;
}

.bg-ff b.inf {
  font-size: 18px;
}

.bg-ff .num {
  font-size: 12px;
  white-space: nowrap;
}

/*PROGRESS*/
/*TABLE*/
.table__block {
  margin: 15px 0 0;
  overflow: hidden;
}

.for-scrolling {
  height: 450px;
  overflow-x: hidden;
  overflow-y: auto;
}

/*WIDTH*/
.for-scrolling::-webkit-scrollbar {
  width: 5px;
}

/* Track */
.for-scrolling::-webkit-scrollbar-track {
  background: #d3d3d3;
}

/* Handle */
.for-scrolling::-webkit-scrollbar-thumb {
  background: #919191;
}

.table-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 30px;
  padding: 5px 10px;
  background: #c7c7c7;
  color: #000;
  font-size: 14px;
}

.table__block table tr {
  cursor: pointer;
}

.table__block table tr.active {
  background: #fcf7ad;
}

.table__block table th {
  padding: 0.4rem;
  background: #dddddd;
  font-size: 12px;
}

.table__block table td {
  padding: 0.3rem;
  font-size: 18px;
}

.trash {
  visibility: hidden;
  opacity: 0;
  -webkit-transition: all 0.2s ease;
  -moz-transition: all 0.2s ease;
  -ms-transition: all 0.2s ease;
  -o-transition: all 0.2s ease;
  transition: all 0.2s ease;
}

.trash.active {
  visibility: visible;
  opacity: 1;
}

.table__block .disabled {
  opacity: 0.5;
}

.table__block .disabled > td:first-child {
  text-decoration: line-through;
}

.table__block table::-webkit-scrollbar {
  width: 10px;
}

/* Track */
.table__block table::-webkit-scrollbar-track {
  background: #919191;
}

/* Handle */
.table__block table::-webkit-scrollbar-thumb {
  background: #e6e6e6;
}

/* Handle on hover */
.table__block table::-webkit-scrollbar-thumb:hover {
  background: #555;
}

/*INFO BLOCK*/
.info__block {
  bottom: 0;
  right: 30px;
  width: 100%;
  max-width: 400px;
}

.info__block::-webkit-scrollbar {
  width: 10px;
}

/* Track */
.info__block::-webkit-scrollbar-track {
  background: #e6e6e6;
}

/* Handle */
.info__block::-webkit-scrollbar-thumb {
  background: #919191;
}

/* Handle on hover */
.info__block::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.accordions,
.cassa {
  width: 100%;
  padding: 5px 8px;
  margin: 0;
  background: #c7c7c7;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;
}

.accordions-dropdown {
  display: none;
  padding: 5px 10px;
  background: #e6e6e6;
  max-height: 250px;
  overflow-y: auto;
  overflow-x: hidden;
}

.cassa_block {
  padding: 5px 10px;
  background: #e6e6e6;
}

.accordions-dropdown li {
  background: transparent;
  border: none;
  padding: 0;
  font-size: 14px;
}

/*WIDTH*/
.accordions-dropdown::-webkit-scrollbar {
  width: 3px;
}

/* Track */
.accordions-dropdown::-webkit-scrollbar-track {
  background: #d3d3d3;
}

/* Handle */
.accordions-dropdown::-webkit-scrollbar-thumb {
  background: #919191;
}

.cassa_block li {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 2px 5px;
  border: none;
  background: #d8d8d8;
}

.cart {
  background-color: #97c7ff;
  z-index: 0;
}

.check {
  background-color: #2083f5;
  text-align: center;
  z-index: 1;
}

.cash {
  background-color: #50e3c2;
  text-align: right;
  z-index: 0;
}

.cart,
.check,
.cash {
  padding: 3px 4px;
  font-size: 12px;
  white-space: nowrap;
  overflow: visible;
}

.absolute {
  position: absolute;
  margin-top: 5px;
  top: 100%;
  left: 0;
}

.r-0 {
  left: auto;
  right: 0;
}

.center {
  left: 50%;
  -webkit-transform: translateX(-50%);
  -moz-transform: translateX(-50%);
  -ms-transform: translateX(-50%);
  -o-transform: translateX(-50%);
  transform: translateX(-50%);
}

/*TOTAL*/
.total {
  background: #e6e6e6;
}

.total li {
  background: transparent;
  border: none;
}

.total .btn {
  padding: 10px 30px;
  background: linear-gradient(180deg, #c8fa92 0%, #b5e97c 50%);
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.5);
  border-radius: 11px;
  font-size: 20px;
  color: #000;
}

.info__block.droped .accordions-dropdown {
  max-height: 150px;
}

/*DELETE MODAL*/
#deleteJob .modal-title {
  font-size: 26px;
  color: #000000;
}

#deleteJob .close {
  opacity: 1;
}

#deleteJob .modal-footer,
#deleteJob .modal-header {
  border: none;
}

#deleteJob .modal-content {
  padding: 10px;
}

.check__number {
  font-size: 18px;
  color: #000000;
  font-weight: bold;
}

.modal_price {
  line-height: 18px;
}

.modal_info span {
  font-size: 18px;
  color: #000000;
}

.car_icon,
.pay_icon {
  max-width: 50px;
}

.cause label {
  padding-left: 10px;
  font-size: 12px;
  color: #4a4a4a;
}

#cause {
  display: block;
  width: 100%;
  background-color: #e9e9e9;
  border-radius: 9px;
  padding: 10px;
  font-size: 13px;
}

.modal_close {
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(180deg, #c8fa92 0%, #b5e97c 50%);
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.5);
  border-radius: 11px;
  color: #000;
}

.modal_close:hover {
  color: #000;
}

.delete_job {
  background: linear-gradient(0deg, #ffc4c9 0%, #fd5e76 100%);
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.5);
  border-radius: 11px;
  color: #000;
}

.delete_job:hover {
  color: #000;
}

/*PAGE - SHIFT*/
/*header*/
.close-shift {
  font-size: 26px;
}

.shift-info-line {
  background: linear-gradient(180deg, #bed7f5 0%, #fffdfd 100%);
}

.shift-info-line .central {
  font-size: 20px;
  font-weight: bold;
}

.shift-info-line sup {
  font-size: 12px;
}

.shift-info-line sub {
  font-size: 14px;
}

/*SHIFT CARDS*/
.shift-cards .card-body {
  background: linear-gradient(
          0deg,
          rgba(226, 226, 226, 0.979922) 0%,
          #fffdfd 100%
  );
  padding: 15px 20px;
}

.shift-cards .card {
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;
}

.shift-cards .card-title {
  position: relative;
  font-weight: bold !important;
  font-size: 12px;
}

.admin-info h4 {
  font-weight: normal;
  font-size: 12px;
}

.shift-cards .panel__body {
  padding: 0;
}

.shift-cards .progress_block {
  align-items: flex-end;
  padding: 0;
  background: transparent;
}

.shift-cards .progress-info {
  justify-content: center;
}

.shift-cards .progress {
  min-height: 24px;
}

.h-24 {
  height: 24px;
  line-height: 24px;
}

.admin-bon {
  display: flex;
  position: absolute;
  align-items: center;
  justify-content: center;
  width: 45px;
  height: 35px;
  background-image: url("../assets/img/page-shift/icon/star.png");
  background-size: 100%;
  line-height: 35px;
  font-size: 10px;
  top: -20px;
  right: 0;
}

.admin-money {
  font-size: 18px;
}

.master-name {
  width: 100px;
  font-size: 12px;
  font-weight: bold;
}

.worker-name {
  font-weight: normal;
}

/*MASTER AND WORKER*/
.master-img {
  width: 68px;
  height: 68px;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
  overflow: hidden;
}

.worker-img {
  width: 48px;
  height: 48px;
  background: #d8d8d8;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
  overflow: hidden;
}

.card-heading {
  padding: 5px;
  font-weight: bold;
  font-size: 12px;
  background: #dab1ff;
}

.mon {
  font-weight: bold;
  font-size: 18px;
}

.card-input input {
  border: 1px solid #979797;
  max-width: 60px;
  text-align: right;
  font-size: 14px;
}

/*range*/
.card-slider {
  font-family: "Helvetica", sans-serif;
  font-size: 12px;
  color: #727272;
}

.money-percent {
  -webkit-appearance: none;
  appearance: none;
  width: 100%;
  height: 2px;
  background: #979797;
  outline: none;
  -webkit-transition: 0.2s;
  transition: opacity 0.2s;
}

.money-percent::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 11px;
  height: 11px;
  background: #f6f6f6;
  box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.5);
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
  cursor: pointer;
}

.money-percent::-moz-range-thumb {
  width: 11px;
  height: 11px;
  background: #f6f6f6;
  box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.5);
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
  cursor: pointer;
}

.card-moneybox .card-body {
  background: rgba(228, 196, 255, 0.72);
}

/*CARDS*/
.card-bonus .card-heading {
  background: #c0fa7f;
}

.card-bonus .card-body {
  background: #d2ffa1;
}

.card-achievement .card-heading {
  background: #ffd700;
}

.card-achievement .card-body {
  background: #ffee99;
}

.card-salary .card-heading {
  background: #ffc971;
}

.card-salary .card-body {
  background: #ffd083;
}

.all_total {
  background: #fef7a4;
  padding: 15px;
}

/*mulct-block*/
.mulct-block {
  position: absolute;
  left: -33px;
  top: 30px;
  padding: 3px 7px;
  background: #d0021b;
  color: #fff;
  font-weight: bold;
  font-size: 11px;
  -webkit-transform: rotate(-90deg);
  -moz-transform: rotate(-90deg);
  -ms-transform: rotate(-90deg);
  -o-transform: rotate(-90deg);
  transform: rotate(-90deg);
}

.additional-info {
  position: absolute;
  display: flex;
  align-items: baseline;
  justify-content: center;
  padding: 5px 9px;
  height: 100%;
  width: 20px;
  background: rgba(228, 181, 102, 0.72);
  color: #000;
  top: 0;
  left: 100%;
}

.additional-info span {
  width: 100%;
  writing-mode: vertical-lr;
}

.accordion {
  width: 100%;
}

.additional-info a {
  align-self: flex-end;
  margin-right: 5px;
}

.worker-row {
  position: relative;
}

.worker-row .all_total {
  justify-content: flex-end !important;
}

.worker-len {
  display: none;
}

.worker-len.active {
  display: block;
}

.card-moneybox {
  display: none;
}

.card-moneybox.active {
  display: block;
}

.display-salary {
  display: none;
}

.display-salary.active {
  display: block;
}

.masters-section {
  overflow-x: hidden;
  overflow-y: auto;
}

/*WIDTH*/
.masters-section::-webkit-scrollbar {
  width: 5px;
}

/* Track */
.masters-section::-webkit-scrollbar-track {
  background: #d3d3d3;
}

/* Handle */
.masters-section::-webkit-scrollbar-thumb {
  background: #919191;
}

.disable-block {
  display: none;
}

.disable-block .disabled-time-block {
  background: #fff;
  padding: 2px 3px;
  font-size: 14px;
  margin-left: 10px;
}

.worker-row.disabled .disable-block {
  display: flex;
  align-items: flex-end;
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background: rgba(216, 216, 216, 0.5);
}

.cassa {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

/*close-shift-button*/
.submit-block p {
  margin: 0;
  font-size: 16px;
}

.submit-block b {
  font-size: 18px;
}

.close-shift-button {
  background: linear-gradient(180deg, #c8fa92 0%, #b5e97c 50%);
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.5);
  border-radius: 11px;
  border: none;
  padding: 5px 30px;
  font-size: 20px;
}

/*MEDIA*/
@media (max-width: 1800px) {
  .info__block {
    bottom: 0;
    right: 0;
    width: 100%;
    max-width: 100%;
    padding: 0 22px;
  }
}

@media (max-width: 1600px) {
  .auto_width {
    overflow-x: scroll;
  }

  /*WIDTH*/
  .auto_width::-webkit-scrollbar {
    width: 3px;
  }

  /* Track */
  .auto_width::-webkit-scrollbar-track {
    background: #d3d3d3;
  }

  /* Handle */
  .auto_width::-webkit-scrollbar-thumb {
    background: #919191;
  }

  header .nav-link {
    font-size: 16px;
  }

  .table__block table td {
    padding: 0.3rem;
    font-size: 15px;
  }
}

@media (max-width: 1570px) {
  .total .list-group-item b,
  .total .list-group-item span {
    font-size: 11px !important;
  }

  .total .btn {
    font-size: 15px;
  }
}

@media (max-width: 1440px) {
  .table__block table td {
    font-size: 10px;
  }

  .table__block table td img {
    width: 17px;
  }

  .acc-btn button .text-part {
    font-size: 14px;
  }

  #myTab .nav-link object {
    width: 60px;
    height: 60px;
  }
}

@media (max-width: 1200px) {
  .accordions,
  .cassa {
    font-size: 12px;
  }

  .accordions img {
    max-width: 20px;
  }

  .accordions-dropdown li {
    background: transparent;
    border: none;
    padding: 0;
    font-size: 11px;
  }

  .cart,
  .check,
  .cash {
    padding: 3px 0;
    font-size: 9px;
  }

  .total .btn {
    font-size: 12px;
  }

  .total li {
    padding: 0.5rem 0.25rem;
  }

  header .nav-link {
    font-size: 13px;
  }

  .info__block {
    position: unset !important;
    padding: 0;
  }

  .for-scrolling {
    overflow: auto;
  }

  body.overflow-hidden {
    overflow-x: hidden !important;
    overflow-y: auto !important;
  }

  .shift-info-line .central {
    font-size: 15px;
    font-weight: bold;
  }
}

@media (max-width: 996px) {
  main {
    overflow: auto !important;
  }

  .shift-cards .card {
    flex: 0 0 100%;
  }

  .shift-info-line sup,
  .shift-info-line sub {
    font-size: 10px;
  }

  .shift-info-line > .col {
    padding: 0;
  }
}

@media (max-width: 767px) {
  .shift-info-line > .col {
    flex: 0 0 50%;
    text-align: center;
  }
  .table-head {
    height: auto;
  }
}

@media (max-width: 575px) {
  .auto_width {
    display: flex;
    flex-wrap: wrap;
  }

  .auto_width > .card {
    width: 100%;
    flex: 0 0 100%;
    max-width: 100%;
    margin-bottom: 15px;
  }

  .for-position {
    margin-top: 15px;
  }

  .bonus__body .panel__body,
  .moneybox .panel__body {
    max-width: 100%;
  }
}

@media (max-width: 415px) {
  .cassa_block li {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 2px;
    border: none;
    background: #d8d8d8;
  }

  .cassa_block li > div {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
  }
}

tr.striked {
  text-decoration: line-through;
}

.profile-card {
  font-family: "Open Sans", Arial, sans-serif;
  position: relative;
  float: left;
  overflow: hidden;
  width: 100%;
  text-align: center;
  border: none;
  z-index: 0;
}

.profile {
  border-radius: 50%;
  position: absolute;
  bottom: 50%;
  left: 50%;
  max-width: 100px;
  opacity: 1;
  box-shadow: 3px 3px 20px rgba(0, 0, 0, 0.5);
  border: 2px solid rgba(255, 255, 255, 1);
  -webkit-transform: translate(-50%, 0%);
  transform: translate(-50%, 0%);
}

.profile-card .card-content {
  width: 100%;
  padding: 15px 25px;
  color: #232323;
  float: left;
  background: #efefef;
  height: 50%;
  border-radius: 0 0 5px 5px;
  position: relative;
  z-index: 9999;
}

.profile-card .profile {
  border-radius: 50%;
  position: absolute;
  bottom: 50%;
  left: 50%;
  max-width: 100px;
  opacity: 1;
  box-shadow: 3px 3px 20px rgba(0, 0, 0, 0.5);
  border: 2px solid rgba(255, 255, 255, 1);
  -webkit-transform: translate(-50%, 0%);
  transform: translate(-50%, 0%);
  z-index: 99999;
}

.profile-card .card-title {
  margin-top: 2rem;
}
</style>
